import { createBrowserRouter, RouterProvider, Outlet } from "react-router";

import 'assets/reset.css'
import { SignIn } from "../pages/signIn";
import { useWebview } from "wiz-front-shared/hooks/useWebview";
import { SignUp } from "pages/signUp";
import { Withdraw } from "pages/withdraw";
import { AccountRecovery } from "pages/account-recovery";
import { useWebviewMessage } from "hooks/useWebviewMessage";
import { useKeyboardInset } from "hooks/useKeyboardInset";
import { setTokens, setUserInfo } from "common/auth";

// 네이티브가 injectedJavaScriptBeforeContentLoaded로 주입한 토큰을
// 모듈 평가 시점에 in-memory 인증 store(common/auth.ts)로 옮긴다.
// useEffect로 처리하면 자식 컴포넌트의 useEffect(API 호출)가 먼저 실행되어
// 토큰이 비어있는 상태로 첫 요청이 나갈 수 있으므로 동기적으로 처리.
if (typeof window !== "undefined") {
    const auth = window.__AUTH__;
    if (auth?.accessToken) {
        setTokens(auth.accessToken, auth.refreshToken);
        if (auth.userId) setUserInfo({ userId: auth.userId });
    }
}

function WebviewProvider() {
    const onMessage = useWebviewMessage();
    useWebview({ onMessage });
    // 하단 고정 버튼이 키보드에 가려지지 않도록 전 화면 공통 처리
    useKeyboardInset();
    return <Outlet />;
}

const router = createBrowserRouter([
    {
        element: <WebviewProvider />,
        children: [
            { path: "/", element: <SignIn /> },
            { path: "/sign-up", element: <SignUp /> },
            { path: "/withdraw", element: <Withdraw /> },
            { path: "/account-recovery", element: <AccountRecovery /> },
        ]
    }
])

export default function Router() {
    return <RouterProvider router={router} />
}
